import * as React from 'react';

export const AddIcon = ({
  width = 24,
  height = width,
  focusable = 'false',
  ...props
}: JSX.IntrinsicElements['svg']) => (
  <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    focusable={focusable}
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 6v6m0 0v6m0-6h6m-6 0H6"
    />
  </svg>
);
